"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const PaginationModule_1 = __importDefault(require("components/shared/PaginationModule/PaginationModule"));
const FooterLimit = ({ currentDataLength, listLimit, currentLimit, setCurrentLimit, currentPage, total, lastUpdated, changePage, hasMore, withFirstLastPage, useDescription = true }) => {
    const basedCount = (currentPage - 1) * currentLimit;
    return (react_1.default.createElement("div", { className: "mt-[12px] pb-[40px] flex justify-between" },
        react_1.default.createElement("div", { className: "flex" },
            listLimit.map((limit, index) => {
                return (react_1.default.createElement(Button_1.default.Tertiary, { customClass: `!text-n-900 border-gray mr-8 border-solid border-[1px] w-[50px] ${currentLimit === limit ? 'bg-base-30016' : ''}`, onClick: () => setCurrentLimit(limit), disabled: false, key: `limit=${index}` }, (0, HelperUtils_1.getObjectiveLocale)(limit)));
            }),
            react_1.default.createElement("div", { className: "my-auto flex" }, useDescription && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: "typography-h400 text-n-800" },
                    (0, HelperUtils_1.getObjectiveLocale)('Show result'),
                    ": ",
                    basedCount + 1,
                    " -",
                    ' ',
                    basedCount + currentDataLength,
                    " ",
                    (0, HelperUtils_1.getObjectiveLocale)('of'),
                    ' ',
                    total,
                    ' '),
                react_1.default.createElement("p", { className: "italic typography-h400 text-n-800" },
                    "\u00A0 ",
                    (0, HelperUtils_1.getObjectiveLocale)('last updated at'),
                    ' ',
                    (0, HelperUtils_1.getDateLocale)(lastUpdated, {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric'
                    })))))),
        react_1.default.createElement(PaginationModule_1.default, { pageNumber: currentPage, handlePrev: () => changePage('prev'), handleNext: () => changePage('next'), handleFirst: () => changePage('first'), handleLast: () => changePage('last'), hasMore: hasMore, withFirstLastPage: withFirstLastPage })));
};
exports.default = FooterLimit;
